/* A file's name, made safe to store under.
 *
 * Supabase Storage accepts a narrow set of characters in a key and refuses
 * everything else outright. Real filenames are not narrow: this program's
 * documents arrive with en dashes, ampersands, apostrophes, accents and
 * ordinary spaces, and "2026-08-25-VIWAPA AMI – PMO - Minutes.docx" is a
 * perfectly reasonable thing for somebody to have saved.
 *
 * So the key is scrubbed and the real name is kept on the row. The person
 * sees what they uploaded; the store gets something it will accept.
 */

const MAX = 120;

export function safeKey(name = "") {
  const raw = String(name).trim();
  const dot = raw.lastIndexOf(".");
  /* A leading dot is a hidden file, not an extension. */
  const hasExt = dot > 0 && dot < raw.length - 1;
  const stem = hasExt ? raw.slice(0, dot) : raw;
  const ext = hasExt ? raw.slice(dot + 1) : "";

  const scrub = (s) => s
    /* Split an accented letter into a plain letter and a mark, then drop the
       mark. Replacing it instead would turn Résumé into Re-sume. */
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^A-Za-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  const body = scrub(stem).slice(0, MAX) || "file";
  const tail = scrub(ext).slice(0, 12).toLowerCase();
  return tail ? `${body}.${tail}` : body;
}

/* Where a document lives. The first folder is the contract, because that is
   what the storage rule reads to decide who may open it. The timestamp keeps
   two files of the same name from landing on each other. */
export const commsPath = (contractId, period, fileName, now = Date.now()) =>
  `${contractId}/comms/${period}/${now}-${safeKey(fileName)}`;
